// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    height: 100vh;
}

.display-flex {
    display: flex;
}

.display-inline-flex {
    display: flex;
    align-content: center;
}

.h-100 {
    height: 100%;
}

.p-16 {
    padding: 16px;
}

.m-16 {
    margin: 16px;
}

.ml-16 {
    margin-left: 16px;
}

.mr-16 {
    margin-right: 16px;
}

.mt-auto {
    margin: auto 0;
}

.csv-download-button {
    cursor: pointer;
    background: none;
    border: none;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":["body {\n    margin: 0;\n    height: 100vh;\n}\n\n.display-flex {\n    display: flex;\n}\n\n.display-inline-flex {\n    display: flex;\n    align-content: center;\n}\n\n.h-100 {\n    height: 100%;\n}\n\n.p-16 {\n    padding: 16px;\n}\n\n.m-16 {\n    margin: 16px;\n}\n\n.ml-16 {\n    margin-left: 16px;\n}\n\n.mr-16 {\n    margin-right: 16px;\n}\n\n.mt-auto {\n    margin: auto 0;\n}\n\n.csv-download-button {\n    cursor: pointer;\n    background: none;\n    border: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
